/**
 * Copyright Mántum All Rights Reserved.
 */
import TextField from '../text';
import { useEffect, useState } from 'react';
import { useGroup, ACTION_VALUE } from '../../group';
import { KEY_FROZEN } from './frozen';

export const KEY_TRACE = 'trace';
export const KEY_TRACE_BASCULE = 'trace-bascule';

type PropTypes = {
    hidden?: boolean;
    name?: string;
    disabled?: boolean;
    onChange?: (name?: string, value?: unknown) => void;
    value?: string | undefined;
};

export default function Trace(props: PropTypes) {
    // prettier-ignore
    const {
        name
    } = props

    const groups = useGroup();
    const [value, setValue] = useState<string | undefined>();

    useEffect(() => {
        const value: string | undefined = props.value ?? '';

        setValue(value);
    }, [props.value]);

    useEffect(() => {
        if (!groups) {
            return;
        }

        if (!(KEY_FROZEN in groups) || !(KEY_TRACE in groups)) {
            return;
        }

        const content = groups[KEY_TRACE];
        if (content.action === ACTION_VALUE) {
            const current = content.value;

            const value =
                current && typeof current === 'string' ? current.trim() : '';

            setValue(value);
        }
    }, [groups]);

    const onChange = (_?: string, value?: unknown) => {
        if (props.onChange) {
            props.onChange(name, value);
        }
    };

    return (
        <div
            className={`${props.hidden ? 'hidden' : 'flex'} items-center gap-2 mx-2`}
        >
            <TextField
                disabled
                testid={`${name}-${KEY_TRACE}`}
                onChange={onChange}
                value={value}
            />
        </div>
    );
}
